module.exports = __webpack_public_path__ + "img/accountingplan_create.c7c161dc.png";